import React from "react";

export default function InternalLink(color) {
    return (<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 2 15 15">
    <g id="fa-internal-link">
      <g fill="none" stroke={color} strokeWidth="1px">
        <path id="fa-internal-link-box-border" d="m 8 3.5 h -4.5 v 8 h 8 l 0 -4.5" />
        <g id="fa-internal-link-arrow">
          <path id="fa-internal-link-arrow-head" d="m 5.5 6 v 3.5 h 3.5" />
          <path id="fa-internal-link-arrow-tail" d="m 10 5 -4.5 4.5" />
        </g>
      </g>
    </g>
  </svg>
    );
}